import type { HomeConfigurationCounts } from "../types"

interface HomeConfigurationCard {
  id: "agents" | "personas" | "test-sets" | "metrics"
  title: string
  count: number
  href: string
  newButtonHref: string
  newButtonLabel: string
  emptyCtaLabel: string
}

export function buildHomeConfigurationCards(
  counts: HomeConfigurationCounts,
  basePath: string,
): HomeConfigurationCard[] {
  return [
    {
      id: "agents",
      title: "Agents",
      count: counts.agent_count ?? 0,
      href: `${basePath}/agents`,
      newButtonHref: `${basePath}/agents/create`,
      newButtonLabel: "+",
      emptyCtaLabel: "Create your first agent",
    },
    {
      id: "personas",
      title: "Personas",
      count: counts.persona_count ?? 0,
      href: `${basePath}/personas`,
      newButtonHref: `${basePath}/personas?id=new`,
      newButtonLabel: "+",
      emptyCtaLabel: "Create your first persona",
    },
    {
      id: "test-sets",
      title: "Test Sets",
      count: counts.test_set_count ?? 0,
      href: `${basePath}/test-sets`,
      newButtonHref: `${basePath}/test-sets/create`,
      newButtonLabel: "+",
      emptyCtaLabel: "Create your first test set",
    },
    {
      id: "metrics",
      title: "Metrics",
      count: counts.metric_count ?? 0,
      href: `${basePath}/metrics`,
      newButtonHref: `${basePath}/metrics?create=true`,
      newButtonLabel: "+",
      emptyCtaLabel: "Create your first metric",
    },
  ]
}
